<!-- 确认上户dialog 组件 -->
<template>
  <section class="dialog">
    <mt-popup v-model="dialogVisible" style="background: transparent">
      <div class="confirm-wrapper">
        <div class="confirm-content">
          <img
            class="head-img"
            src="https://hzwimspic-1251601690.image.myqcloud.com/45220617-68bd-43be-b140-0d5a8f6fe571"
          />
          <p class="title">
            <span>亲爱的会员</span><br /><span>月嫂服务已为您开启!</span>
          </p>
          <div class="content">
            <!-- 您的专属月嫂已详细记录每日服务内容，从宝宝喂养到妈妈护理，点滴细节均可追溯便捷查看方式：打开孩子王APP或小程序，首页「我的」模块一键直达电子日志：或进入「订单详情页」，随时回顾服务全程。用心记录，让爱有迹可循! -->
            您的专属月嫂已详细记录每日服务内容从宝宝喂养到妈妈护理用心记录，让爱有迹可循。
          </div>
          <div class="btn-view-log" @click.once="handleClickBtnViewLog">
            查看服务日志
          </div>
        </div>
        <img
          class="cancel-btn-img"
          src="https://hzwimspic-1251601690.image.myqcloud.com/4c47921e-dd87-47c7-a0e2-5d9ca67fbfde"
          @click="close"
        />
      </div>
    </mt-popup>
  </section>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { Popup } from 'mint-ui'

export default {
  inject: ['reload'],
  //import引入的组件需要注入到对象中才能使用
  components: {
    [Popup.name]: Popup
  },
  data() {
    //这里存放数据
    return {
      dialogVisible: false
    }
  },
  props: {
    order: {
      default: {},
      type: Object
    }
  },
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    open() {
      this.dialogVisible = true
    },
    close() {
      this.dialogVisible = false
      this.reload()
    },
    handleClickBtnViewLog() {
      this.reload()
      location.href = `/v/yuesao-serve/log-detail-user?kwtarget=blank`
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {}
}
</script>
<style lang="scss">
.mint-popup {
  background: #ffffff;
  border-radius: 28px !important;
}
</style>
<style lang="scss" scope>
@import '~@/assets/css/mixin';
//@import url(); 引入公共css类
.dialog {
  .confirm-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .confirm-content {
      width: rem(620px);
      background: url('https://hzwimspic-1251601690.image.myqcloud.com/4553eb20-7d50-4848-80c2-2147022d912f');
      background-size: rem(620px) rem(240px);
      background-repeat: no-repeat;

      background-color: #ffffff;

      padding: rem(40px) rem(40px) rem(50px) rem(40px);

      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .head-img {
        width: rem(300px);
        height: rem(220px);
        position: absolute;
        left: calc(50% - rem(150px));
        top: rem(-180px);
      }

      .title {
        margin-top: rem(10px);
      }

      .title span {
        display: inline; /* 或者 block，根据需要选择 */
        background-image: linear-gradient(270deg, #ff5900 0%, #ff8800 100%);
        background-size: 100% rem(12px); /* 控制下划线的高度和宽度 */
        background-position: 0 88%; /* 调整下划线的位置 */
        background-repeat: repeat-x; /* 让下划线重复 */
        color: #121212;
        font-weight: 600;
        font-size: rem(36px);
      }

      .content {
        margin-top: rem(32px);
        margin-bottom: rem(44px);
        font-size: rem(28px);
        font-weight: 400;
        color: #363636;
        text-align: left;
      }

      .btn-view-log {
        height: rem(90px);
        width: rem(540px);
        line-height: rem(87px);
        mix-blend-mode: normal;
        border-radius: rem(66px);
        background: linear-gradient(270deg, #ff5900 0%, #ff8800 100%);
        font-weight: 500;
        font-size: rem(32px);
        color: #ffffff;
      }
    }

    .cancel-btn-img {
      margin-top: rem(60px);
      width: rem(60px);
      height: rem(60px);
    }
  }
}
</style>
